import React, { Component, useEffect, useState } from "react"
import { connect } from 'react-redux'
import { Div, Input, DatePicker, Select, TextArea } from "../../components/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import FormLabel from '@material-ui/core/FormLabel';
import { msg } from '../../components/Notifications/MsgBox';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { SecureGateRoute, BreadCrumb, PanelExpand, SearchEmployeeModal, UploadButton, DocumentModal, DocumentNotApproveModal } from '../../components';
import { Storage, AppSettings } from '../../configs'
import '../../assets/css/tor-template-list.css'
import { ChangeCommitteeService } from '../../services';
import moment from 'moment'
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router";
import CustomDialog from "../../components/Notifications/Dialog";
import UserServices from '../../services/UserServices';

const objChangeCommittee = {
    action_by: null,
    action_date: null,
    approve_status: null,
    approve_status_name: null,
    approver_code: "",
    approver_fullname: null,
    attachments: null,
    change_no: null,
    change_reason_description: null,
    details: [],
    effective_date: null,
    logs: [],
    po_contract_no: "",
    po_header_text: "",
    requester_code: null,
    requester_fullname: null,
    running: 0,
    transaction_change_no: "",
    reason: ""
}

const ChangeCommitteeScreen = (props) => {
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const history = useHistory();
    const user = Storage.getUser();
    const emp = Storage.getEmployeePIS();
    let { runningId } = useParams();
    const [openLoading, setOpenLoading] = React.useState(false);
    const [viewMode, setViewMode] = React.useState(false);

    const [stateChangeCommittee, SetStateChangeCommittee] = useState({});
    const [showErrorPOContractNo, setShowErrorPOContractNo] = React.useState(false);
    const [indexSelect, setindexSelect] = useState(0);
    const [emptypeSearch, setemptypeSearch] = useState('');
    
    const [isOpenConfirmReject,setIsOpenConfirmReject] = React.useState(false);
    const [isOpenSaveSuccess,setIsOpenSaveSuccess] = React.useState(false);

    const [openConfirmCommittee,setOpenConfirmCommittee] = React.useState(false);
    const [lineTextConfirmCommiteeAmount,setLineTextConfirmCommiteeAmount] = React.useState([]);
    const [lineTextConfirmCommiteeAmountSubject,setLineTextConfirmCommiteeAmountSubject] = React.useState('');
    const [searchPoContractNoResult,setSearchPoContractNoResult] = React.useState(null);
    const [appReadonly,setAppReadonly] = useState(true);
    

    const handleApplicationCheckReadonly = async () =>
        {
            UserServices.ApplicationReadonly().then(response=>{
                if(response.data === false)
                {
                    setAppReadonly(false)
                }else{
                    setViewMode(true)
                }
            })
        }

      useEffect(() => {
        SetStateChangeCommittee({...objChangeCommittee})
        handleApplicationCheckReadonly();
          if (runningId != 0) {
              GetChangeCommitteeById(runningId);
          }
       
      }, [runningId])

      function GetChangeCommitteeById(runningId) {
        try {
            setOpenLoading(true)
            ChangeCommitteeService.getChangeCommittee(runningId).then((response) => {

                    
                    SetStateChangeCommittee({
                        ...stateChangeCommittee,
                        running: response.running,
                        action_by: emp.employeeId,
                        action_date: response.action_date,
                        approve_status: response.approve_status,
                        approve_status_name: response.approve_status_name,
                        approver_code: response.approver_code,
                        approver_fullname: response.approver_fullname,
                        attachments: response.attachments,
                        change_no: response.change_no,
                        change_reason_description: response.change_reason_description,
                        details: response.details,
                        effective_date: response.effective_date,
                        logs: response.logs,
                        po_contract_no: response.po_contract_no,
                        po_header_text: response.po_header_text,
                        requester_code: response.requester_code ?? emp.employeeId,
                        requester_fullname: response.requester_fullname ?? emp.employeeNameTH,
                        transaction_change_no: response.transaction_change_no,
                        reason: response.reason
                    })
                    if((response.approve_status == null || response.approve_status == "DRAFT") && appReadonly === false){
                        setViewMode(false)
                    }
                    else
                    {
                        setViewMode(true)
                    }
                    
                    setOpenLoading(false)
            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false)
        }
      }

    const handleChange = (event) => {

        const target = event.target
        let value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }

        stateChangeCommittee[name] = value;
        SetStateChangeCommittee({ ...stateChangeCommittee});

    }

    const handleChangeCommittee = (index, event) => {

        const target = event.target
        let value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value
        const name = target.name

        stateChangeCommittee.details[index].reason = value;
        SetStateChangeCommittee({ ...stateChangeCommittee })


    }

    const handleSearch = (event) => {
        SearchPoContractNo(stateChangeCommittee.po_contract_no);
    };

    const  handleShowCommittee = async(callback) => {

        //this.openConfirmModal(event)
        setOpenLoading(true)
        const response = await ChangeCommitteeService.getIsCheckPOCommitteeConfirmAmountByPO(stateChangeCommittee.po_contract_no)
        if(response)
        {
            
            if(response.isSuccess === true)
            {
                if(response.data.isCheckPOCommitteeConfirmAmount === true)
                {
                    setOpenConfirmCommittee(true)
                    setLineTextConfirmCommiteeAmount(response.data.lines)
                    setLineTextConfirmCommiteeAmountSubject(response.data.subject)
                    
                }else{
                    if(typeof callback === 'function')
                    {
                        callback(true)
                    }
                }

                setOpenLoading(false)
            }else{
                
                setOpenLoading(false)
            }
        }else{
            setOpenLoading(false)
        }
    }

    const handleConfirmCommittee = (event) =>{
        setOpenConfirmCommittee(false)
        setLineTextConfirmCommiteeAmount([])
        setLineTextConfirmCommiteeAmountSubject('')

        SetStateChangeCommittee({
            ...searchPoContractNoResult,
        })
    }

    const handleOnCloseConfirmCommittee = () =>{
        setOpenConfirmCommittee(false)
        setLineTextConfirmCommiteeAmount([])
        setLineTextConfirmCommiteeAmountSubject('')
    }

    function SearchPoContractNo(poContractNo) {

        try {
            if (poContractNo == '' || poContractNo == null) {
                msg.warning("กรุณาระบุ PO/Contract No.");
                return
            }
            else {
                setOpenLoading(true)
                ChangeCommitteeService.searchPoContractNo(poContractNo).then((response) => {

                    
                    if (response.isSuccess == true) {
                        let dataResponse = response.resData
                        if (dataResponse != null) {
                            if (dataResponse.po_contract_no) {

                                setSearchPoContractNoResult({
                                    ...stateChangeCommittee,
                                    running: runningId,
                                    action_by: emp.employeeId,
                                    action_date: dataResponse.action_date,
                                    approve_status: dataResponse.approve_status,
                                    approve_status_name: dataResponse.approve_status_name,
                                    approver_code: dataResponse.approver_code,
                                    approver_fullname: dataResponse.approver_fullname,
                                    attachments: stateChangeCommittee.attachments != null ? stateChangeCommittee.attachments : dataResponse.attachments,
                                    change_no: dataResponse.change_no,
                                    change_reason_description: dataResponse.change_reason_description,
                                    details: dataResponse.details,
                                    effective_date: dataResponse.effective_date,
                                    logs: dataResponse.logs,
                                    po_contract_no: dataResponse.po_contract_no,
                                    po_header_text: dataResponse.po_header_text,
                                    requester_code: dataResponse.requester_code ?? emp.employeeId,
                                    requester_fullname: dataResponse.requester_fullname ?? emp.employeeNameTH,
                                    reason: response.reason
                                });

                                handleShowCommittee(function(resShowComiitee){

                                    if(resShowComiitee)
                                    {
                                        SetStateChangeCommittee({
                                            ...stateChangeCommittee,
                                            running: runningId,
                                            action_by: emp.employeeId,
                                            action_date: dataResponse.action_date,
                                            approve_status: dataResponse.approve_status,
                                            approve_status_name: dataResponse.approve_status_name,
                                            approver_code: dataResponse.approver_code,
                                            approver_fullname: dataResponse.approver_fullname,
                                            attachments: stateChangeCommittee.attachments != null ? stateChangeCommittee.attachments : dataResponse.attachments,
                                            change_no: dataResponse.change_no,
                                            change_reason_description: dataResponse.change_reason_description,
                                            details: dataResponse.details,
                                            effective_date: dataResponse.effective_date,
                                            logs: dataResponse.logs,
                                            po_contract_no: dataResponse.po_contract_no,
                                            po_header_text: dataResponse.po_header_text,
                                            requester_code: dataResponse.requester_code ?? emp.employeeId,
                                            requester_fullname: dataResponse.requester_fullname ?? emp.employeeNameTH,
                                            reason: response.reason
                                        })
                                    }
                                });

                                
                            }else{
                                setOpenLoading(false)
                            }
                        }else{
                            setOpenLoading(false)
                        }
                        
                    } else {
                        msg.error(response.returnMessage);
                        setOpenLoading(false)
                    }

                    
                })
            }
        } catch (e) {
            console.log(e);
            setOpenLoading(false)
        }
    }
    function validate() {
        let isError = false;
        let msgError = "";

        if(stateChangeCommittee.action_by == null || stateChangeCommittee.action_by == ""){
            msgError += "<br/>กรุณาระบุ ผู้ขอ";
        }
        if(stateChangeCommittee.requester_code == null || stateChangeCommittee.requester_code == ""){
            msgError += "<br/>กรุณาระบุ ผู้ขอ";
        }
        if(stateChangeCommittee.approver_code == null || stateChangeCommittee.approver_code == ""){
            msgError += "<br/>กรุณาระบุ ผู้อนุมัติ";
        }
        if(stateChangeCommittee.attachments == null || stateChangeCommittee.attachments.length == 0){
            msgError += "<br/>กรุณาระบุ เอกสารอ้างอิงแต่งตั้งคณะกรรมการตรวจรับ";
        }

        let is_not_committee = true
        stateChangeCommittee && stateChangeCommittee.details.map((row, index) => {
            if (row.is_change_committee == true) {
                is_not_committee = false;
                if(stateChangeCommittee.approver_code == row.change_committee_code){
                    msgError += "<br/>คณะกรรมการจะต้องไม่ซ้ำกับผู้อนุมัติ";
                }
            }
        })

        if(is_not_committee){
            msgError += "<br/>กรุณาระบุ คณะกรรมการตรวจรับใหม่";
        }

        if(stateChangeCommittee.change_reason_description == null || stateChangeCommittee.change_reason_description == ""){
            msgError += "<br/>กรุณาระบุ รายละเอียดเปลี่ยนแปลงกรรมการ";
        }
        if(stateChangeCommittee.effective_date == null){
            msgError += "<br/>กรุณาระบุ มีผลตั้งแต่";
        }

        if(msgError != ""){
            msgError = msgError.substring(5);
            msg.warning(msgError);
            isError = true;
        }
        
        return isError;
    }

    function handleSubmit(event) {
        if (validate()) {
            return;
        }
        
        console.log("setChangeCommittee");

        stateChangeCommittee.approve_status = "WAITFAPP";
        stateChangeCommittee.requester_code = emp.employeeId;
        stateChangeCommittee.requester_fullname = emp.employeeNameTH;
        stateChangeCommittee.action_by = emp.employeeId;
        save(stateChangeCommittee);
    }
    function handleApprove(event) {
        if (validate()) {
            return;
        }
        let objChangeCommittee = {...stateChangeCommittee}
        objChangeCommittee.approve_status = "APPROVE";
        save(objChangeCommittee);
    }
    function handleReject(event) {
        if (validate()) {
            return;
        }
        setIsOpenConfirmReject(true);
    }

    const handleOnClickReject = () => {

        let objChangeCommittee = { ...stateChangeCommittee }
            objChangeCommittee.approve_status = "REJECT";

            if (objChangeCommittee.reason) {
                setIsOpenConfirmReject(false);
                save(objChangeCommittee);
            }
    }

    function save(objChangeCommittee) {
        try {
            setOpenLoading(true)
            console.log("setChangeCommittee save : >>");
            
            ChangeCommitteeService.setChangeCommittee(objChangeCommittee).then((response) => {
                console.log("setChangeCommittee response : >>");
                
                
                if (response.isSuccess == true) {
                    //msg.success(response.returnMessage);
                    setIsOpenSaveSuccess(true)
                } else {
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false)

            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false)
        }
    }

    const handleOnClickSuccess = () => {
        setIsOpenSaveSuccess(false)
        history.push(`/ChangeCommitteeTask`);
    }

    function searchEmployeeModal(index, type) {
        setindexSelect(index)
        setemptypeSearch(type)
        window.$('#searchEmployeeModal').modal('show');

    }

    const onSelected = (objitem) => {
        
        if (emptypeSearch == "committee") {
            
            if (objitem) {
                stateChangeCommittee.details[indexSelect].is_change_committee = true;
                stateChangeCommittee.details[indexSelect].change_committee_code = objitem.employeeId;
                stateChangeCommittee.details[indexSelect].change_committee_fullname = objitem.iname + " " + objitem.employeeNameTH;
                SetStateChangeCommittee({ ...stateChangeCommittee })
            }
        }
        if(emptypeSearch == "approver"){
            if (objitem) {
                stateChangeCommittee.approver_code = objitem.employeeId;
                stateChangeCommittee.approver_fullname = objitem.iname + " " + objitem.employeeNameTH;
                SetStateChangeCommittee({ ...stateChangeCommittee })
            }
        }
        
    };

    function openAttachedDocumentNormalModal(transaction_change_no) {
        //window.$(`#filename_NTC`).val('เอกสารแนบ');
        //window.$(`#file_id`).val(transaction_change_no);
        //window.$(`#file_transaction_no`).val(transaction_change_no);
        window.$('#attachedChangeCommitteeModal').modal('show');

    }

    function IsShowsLoading(props) {
        const { isLoading } = props;
        return (
            (isLoading ?
                <div id="loading-element">
                    <div id="loading-indicator">
                        <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                </div>
                : null)
        )
    }


    const onChangeSelectedFile = (file, file_type) => {

    }

    const onUploadComplete = (modalId) => {
    
        try {
            setOpenLoading(true)
            ChangeCommitteeService.getCommitteeAttachments(stateChangeCommittee.transaction_change_no).then((response) => {
                console.log("getCommitteeAttachments");
                
                let dataresponse = response

                response && response.map((dataattachments, index) => {
                  
                    if (stateChangeCommittee.attachments != null) {
                        let _item = stateChangeCommittee.attachments.find(f => f.running === dataattachments.running)
                        if (_item != null) {
                            dataresponse[index].isActive = _item.isActive;
                        }
                    }
                })
                console.log("getCommitteeAttachments => :");
                
                stateChangeCommittee.attachments = dataresponse
                SetStateChangeCommittee({ ...stateChangeCommittee })
                setOpenLoading(false)

            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false)
        }

    }

    const onUploadCancel =  (modalId) => {    
   
    }

    const onDeleteConfirm = (event, item, index) => {
        console.log("onDeleteConfirm => :");
        
        if (index != null) {
            msg.showConfirm(
                "Confirm",
                "ต้องการลบรายการนี้หรือไม่",
                () => {
                    msg.hideConfirm()
                    stateChangeCommittee.attachments[index].isActive = false;
                    SetStateChangeCommittee({ ...stateChangeCommittee })
                    msg.success("ลบรายการสำเร็จ")
                },
                () => {
                    msg.hideConfirm()
                    console.log("ยกเลิกการลบรายการ")
                },
                () => {
                    console.log("ยกเลิกการลบรายการ")
                }
            )
        }
    }

    return (
        <div className="tor tor-template-list">
            <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
            <SecureGateRoute />
            <div id="main-content">
                <div className="page-body">
                    <BreadCrumb breadcrumb={[
                        { name: 'RRS Home', url: AppSettings.defaultUrl },
                        { name: 'เปลี่ยนแปลงคณะกรรมการตรวจรับ', url: '/ChangeCommitteeTask' },
                        { name: 'รายละเอียดเปลี่ยนแปลงคณะกรรมการตรวจรับ', url: '' }
                    ]}></BreadCrumb>

                    <div className="sp-page-header-panel row">
                        <div className="col-md-5 sp-page-header">
                            <h1 className="sp-page-header1">เปลี่ยนแปลงคณะกรรมการตรวจรับ</h1>
                        </div>
                    </div>

                    <div className="sp-page-result-container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label " style={{ color: '#0036C1', fontWeight: 'bold' }}>Status : </label>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                <text style={{ color: stateChangeCommittee.approve_status == 'REJECT' ? '#ff0000' :'#2D9714' }}>{stateChangeCommittee.approve_status_name ?? 'Draft'}</text>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="form-group">
                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                {
                                                    stateChangeCommittee.approve_status == 'REJECT' ? (<input
                                                        type="text"
                                                        id="reason"
                                                        name="reason"
                                                        className="form-control"
                                                        defaultValue={stateChangeCommittee.reason ?? ''}
                                                        disabled={true}
                                                    />) : ('')
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                <text style={{ color: 'red' }}>*</text><label className="rrs-label ">PO/Contract No. : </label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="po_contract_no"
                                            name="po_contract_no"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            defaultValue={stateChangeCommittee.po_contract_no ?? ''}
                                            onBlur={handleChange}
                                            onChange={handleChange}
                                            autoComplete="off"
                                            disabled={viewMode}
                                        />
                                        {showErrorPOContractNo && <FormLabel className="Mui-error">ไม่พบข้อมูล</FormLabel>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1">
                                {
                                viewMode ? ('') : (<a onClick={handleSearch} style={{ cursor: 'pointer' }} disabled={true}>
                                <i className="icon bt-search icon-xs" />
                                </a>)
                                }
                                
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">ชื่องาน : </label>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="po_header_text"
                                            name="po_header_text"
                                            className="form-control"
                                            defaultValue={stateChangeCommittee.po_header_text ?? ''}
                                            onChange={handleChange}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">ผู้ขอ : </label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="requester_fullname"
                                            name="requester_fullname"
                                            className="form-control"
                                            value ={stateChangeCommittee.requester_code != '' ? stateChangeCommittee.requester_fullname + ' (' + stateChangeCommittee.requester_code + ')' : emp.employeeNameTH + ' (' + emp.employeeId + ')'}
                                            onChange={handleChange}
                                            disabled={true}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">ผู้อนุมัติ : </label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <Input
                                            key={`approver_fullname`}
                                            value={stateChangeCommittee.approver_fullname != null ? stateChangeCommittee.approver_fullname + ' (' + stateChangeCommittee.approver_code + ')' : ''}
                                            className="form-control form-control-search-2 control-icon-search"
                                            id="approver_fullname"
                                            name="approver_fullname"
                                            onClick={() => searchEmployeeModal(0, "approver")}
                                            disabled={viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="History เปลี่ยนแปลงคณะกรรมการตรวจรับ" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                    <React.Fragment>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Table className="sp-table table rrs-table">
                                                    <TableHead>
                                                        <TableRow className="sp-table-header" style={{ backgroundColor: '#B6D0FB' }}>
                                                            <TableCell className="th-table text-center" style={{ width: '200px' }}>ดำเนินการวันที่
                                                            </TableCell>
                                                            <TableCell className="th-table text-center" style={{ width: '250px' }}>ดำเนินการโดย
                                                            </TableCell>
                                                            <TableCell className="th-table text-center" >รายละเอียดการเปลี่ยนแปลงกรรมการ</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            stateChangeCommittee.logs ? (

                                                                stateChangeCommittee.logs.map((datalogs, index) => {

                                                                    return (
                                                                        <TableRow key={index}>
                                                                            <TableCell className="text-left" style={{ width: '25%' }}>{datalogs.action_date ? moment(datalogs.action_date).format('DD/MM/YYYY') : ''}</TableCell>
                                                                            <TableCell className="text-left" style={{ width: '25%' }}>{datalogs.action_fullname}</TableCell>
                                                                            <TableCell className="text-left" style={{ width: '50%' }}>{datalogs.change_reason_description}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })) : (
                                                                <TableRow key={0}>
                                                                    <TableCell colSpan="11" className="text-center" style={{
                                                                        textAlign: 'center',
                                                                        fontStyle: 'italic',
                                                                        color: 'gray',
                                                                    }}>No data</TableCell>
                                                                </TableRow>
                                                            )
                                                        }

                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title={<><text style={{ color: 'red' }}>*</text><text> เอกสารอ้างอิงแต่งตั้งคณะกรรมการตรวจรับ</text></>} titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                    <React.Fragment>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <div className="row">
                                                    <div className="col-md-10 "></div>
                                                    <div className="col-md-2 ">
                                                        {
                                                            (stateChangeCommittee.approve_status === "" || stateChangeCommittee.approve_status == null) ? (<a style={{ cursor: 'pointer' }} onClick={() => openAttachedDocumentNormalModal(stateChangeCommittee.transaction_change_no)}>
                                                                <i className="icon btn-order-upload" />
                                                            </a>) : (<></>)
                                                        }
                                                    </div>
                                                </div>
                                                <Table className="sp-table table rrs-table">
                                                    <TableHead>
                                                        <TableRow className="sp-table-header" style={{ backgroundColor: '#0072BC' }}>
                                                            <TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>No.
                                                            </TableCell>
                                                            <TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>ชื่อเอกสารแนบ
                                                            </TableCell>
                                                            <TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>คำอธิบาย</TableCell>
                                                            {
                                                                viewMode === false && (<TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>ลบ</TableCell>)
                                                            }
                                                            <TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>แสดง</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {
                                                            stateChangeCommittee.attachments ? (

                                                                stateChangeCommittee.attachments.filter(f => f.isActive == true).map((dataattachments, index) => {

                                                                    return (
                                                                        <TableRow key={index}>
                                                                            <TableCell className="text-left" style={{ width: '10%' }}>{index + 1}</TableCell>
                                                                            <TableCell className="text-left" style={{ width: '25%' }}>{dataattachments.file_name}</TableCell>
                                                                            <TableCell className="text-left" >{dataattachments.file_description}</TableCell>
                                                                            {
                                                                                viewMode === false && (
                                                                                    <TableCell className="text-center" style={{ width: '10%' }}>
                                                                                        <a onClick={(event) => onDeleteConfirm(event, dataattachments, index)}><i className="icon btn-minus" /></a>
                                                                                    </TableCell>)
                                                                            }

                                                                            <TableCell className="text-left" style={{ width: '10%' }}><a href={dataattachments.file_url} target="_blank"><i className="icon icon-preview-eye-blue" /></a></TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })) : (
                                                                <TableRow key={0}>
                                                                    <TableCell colSpan="11" className="text-center" style={{
                                                                        textAlign: 'center',
                                                                        fontStyle: 'italic',
                                                                        color: 'gray',
                                                                    }}>No data</TableCell>
                                                                </TableRow>
                                                            )
                                                        }

                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-center" style={{
                                fontWeight: 'bold',
                                fontSize: '20px',
                                color: '#4D4D4D'
                            }}>
                                คณะกรรมการตรวจรับ
                            </div>
                        </div>
                        <Grid container>
                            <Grid item xs={12}>
                                <Table className="sp-table table rrs-table">
                                    <TableHead>
                                        <TableRow className="sp-table-header" style={{ backgroundColor: '#B6D0FB' }}>
                                           
                                            <TableCell className="th-table text-center" style={{ width: '25%' }} >คณะกรรมการตรวจรับปัจจุบัน
                                            </TableCell>
                                            <TableCell className="th-table text-center" style={{ width: '25%' }} >คณะกรรมการตรวจรับใหม่
                                            </TableCell>
                                            <TableCell className="th-table text-center" style={{ width: '15%' }} >ตำแหน่ง</TableCell>
                                            <TableCell className="th-table text-center" style={{ width: '33%' }} >เหตุผล</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {
                                            stateChangeCommittee.details ? (

                                                stateChangeCommittee.details.map((acceptance, index) => {

                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell className="text-left" style={{ width: '25%' }}>{acceptance.fullname}</TableCell>
                                                            <TableCell className="text-center" style={{ width: '25%' }}>
                                                                <Input
                                                                    key={`acceptance_committee_name_${index}`}
                                                                    value={acceptance.change_committee_fullname != null ? acceptance.change_committee_fullname + '(' + acceptance.change_committee_code + ')' : ''}
                                                                    className="form-control form-control-search-2 control-icon-search"
                                                                    id={`acceptance_committee_name_${index}`}
                                                                    name={`acceptance_committee_name_${index}`}
                                                                    onClick={() => searchEmployeeModal(index, "committee")}
                                                                    disabled={viewMode}
                                                                />
                                                            </TableCell>
                                                            <TableCell className="text-left" style={{ width: '15%' }}>
                                                                {
                                                                   acceptance.position_committee
                                                                }
                                                            </TableCell>
                                                            <TableCell className="text-left" style={{ width: '35%' }}>
                                                                <input
                                                                    type="text"
                                                                    id={`reason${index}`}
                                                                    name={`reason${index}`}
                                                                    className="form-control"
                                                                    value={acceptance.reason}
                                                                    onChange={(e) => handleChangeCommittee(index, e)}
                                                                    disabled={viewMode}
                                                                />
                                                               
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                })) : (
                                                <TableRow key={0}>
                                                    <TableCell colSpan="11" className="text-center" style={{
                                                        textAlign: 'center',
                                                        fontStyle: 'italic',
                                                        color: 'gray',
                                                    }}>No data</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                    {/* <TableBody>
                                    <TableRow key={0}>
                                                    <TableCell colSpan="11" className="text-center" style={{
                                                        textAlign: 'center',
                                                        fontStyle: 'italic',
                                                        color: 'gray',
                                                    }}>No data</TableCell>
                                                </TableRow>
                                    </TableBody> */}
                                </Table>
                            </Grid>
                        </Grid>

                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                <text style={{ color: 'red' }}>*</text><label className="rrs-label ">รายละเอียดเปลี่ยนแปลงกรรมการ : </label>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="change_reason_description"
                                            name="change_reason_description"
                                            className="form-control"
                                            defaultValue={stateChangeCommittee.change_reason_description ?? ''}
                                            onChange={handleChange}
                                            disabled={viewMode}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                <text style={{ color: 'red' }}>*</text><label className="rrs-label ">มีผลตั้งแต่ : </label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>

                                        <DatePicker
                                            name="effective_date"
                                            id="effective_date"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={stateChangeCommittee.effective_date
                                                ? moment(stateChangeCommittee.effective_date).format('DD/MM/YYYY')
                                                : ""}
                                            onChange={handleChange}
                                            onBlur={handleChange}
                                            readOnly={true}
                                            disabled={viewMode}
                                        //ref={this.create_date_from_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rrs-detail py-1">
                            <div className="row sp-table-content-footer">
                                { appReadonly === false && <div className="col-12 sp-header-button-panel2">
                                    {
                                        stateChangeCommittee?
                                        stateChangeCommittee.approve_status == null ?  (
                                                <>
                                                    <a className="sp-btn-icon" onClick={handleSubmit}>
                                                        <i className="icon btn-order-publish" />
                                                        <span className="sp-btn-icon-label3">Submit</span>
                                                    </a>
                                                </>):stateChangeCommittee.approve_status === "WAITFAPP" && stateChangeCommittee.approver_code == emp.employeeId ?    
                                                 (<>
                                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleApprove}>
                                                        <i className="icon btn-approval-green"></i>
                                                        <span className="sp-btn-icon-label3">Approve</span>
                                                    </a>

                                                    <a className="sp-btn-icon" onClick={handleReject}>
                                                        <i className="icon btn-reject-red" />
                                                        <span className="sp-btn-icon-label2">Reject</span>
                                                    </a>
                                                </>):(<></>):(
                                                <>
                                                    <a className="sp-btn-icon" onClick={handleSubmit}>
                                                        <i className="icon btn-order-publish" />
                                                        <span className="sp-btn-icon-label3">Submit</span>
                                                    </a>
                                                </>)
                                    }

                                </div>}
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <SearchEmployeeModal
                onSelected={(objitem) => onSelected(objitem)}
            ></SearchEmployeeModal>

            <DocumentModal></DocumentModal>

            <DocumentNotApproveModal
                dataId={stateChangeCommittee.transaction_change_no}
                onChangeSelectedFile = {(selectedFile,file_type) => onChangeSelectedFile(selectedFile, file_type)}
                onUploadComplete={(attmentid) => onUploadComplete(attmentid)}
                onUploadCancel={(attmentid) => onUploadCancel(attmentid)}
            ></DocumentNotApproveModal>

            <CustomDialog open={isOpenConfirmReject} title="Message" maxWidth="sm" 
                onClose={() => {
                    setIsOpenConfirmReject(false)
                }}
            >

                <Grid container style={{ marginTop: 20 }} spacing={3}>
                    <Grid item xs={12} sm={3}>
                        <Typography align='right'>เหตุผล</Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <TextField
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            name="reason"
                            defaultValue={stateChangeCommittee.reason}
                            onChange={handleChange}
                            helperText={stateChangeCommittee.reason ? "" : "กรุณาระบุเหตผล"}
                            error={!stateChangeCommittee.reason}
                            maxLength={250}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container
                            justifyContent="center"
                            alignItems="center">
                            <Grid item xs={2}>
                                <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickReject}>
                                    <i className="icon btn-order-check-green" />
                                    <span className="sp-btn-icon-label">ยืนยัน</span>
                                </a>
                            </Grid>
                            <Grid item xs={2}>
                                <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={() => { setIsOpenConfirmReject(false) }}>
                                    <i className="icon btn-order-cancel" />
                                    <span className="sp-btn-icon-label">ยกเลิก</span>
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CustomDialog>

            <CustomDialog open={isOpenSaveSuccess} title="Success" maxWidth="sm" msgType="success"  onClose={handleOnClickSuccess}>

                <Grid container style={{ marginTop: 20 }} spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <Typography align='center'>บันทึกสำเร็จ</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container
                            justifyContent="center"
                            alignItems="center">
                            <Grid item xs={2}>
                                <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickSuccess}>
                                    <i className="icon btn-order-check-green" />
                                    <span className="sp-btn-icon-label">ตกลง</span>
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CustomDialog>
            <CustomDialog open={openConfirmCommittee} title={lineTextConfirmCommiteeAmountSubject} maxWidth="lg"
                onClose={()=>{
                    handleOnCloseConfirmCommittee()
                }}
                PaperProps={{style: {maxWidth: 1040}}}
                propsTitle={{align: 'center', variant: 'h5', typographyProps: {style:{ marginTop: 12, marginBottom: 12}}}}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign: 'center'}}>
                            {
                                lineTextConfirmCommiteeAmount.map((p, i)=> (<label className='font-radio' key={'txt-ConfirmCommittee-line'+i}>{p.display}</label>))
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={1}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={(event) => {handleConfirmCommittee(event)}}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label3-success">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={1}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>handleOnCloseConfirmCommittee()}>
                                        <i className="icon btn-cancel-size-check" />
                                        <span className="sp-btn-icon-label3-cancel">ย้อนกลับ</span>
                                    </a>
                                </Grid>
                            </Grid>
                            
                        </Grid>
                    </Grid>
                </CustomDialog>
        </div>
        
    );

}

export default ChangeCommitteeScreen